import "./ContactUsPage.css";
import PageHeader from "../../../components/ui/page header/PageHeader";
import { useTranslation } from "react-i18next";
import ContactUsForm from "./components/contactUsForm/ContactUsForm";
import ContactUsInfo from "./components/contactUsInfo/ContactUsInfo";

function ContactUsPage() {
  const { t } = useTranslation("contact");

  return<>
    <PageHeader
      topic={t("pageHeader.topic")}
      topicSentence={t("pageHeader.topicSentence")}
    />
    <section className="contactUs-section">
      <div className="container">
        <ContactUsForm/>
        <ContactUsInfo/>
      </div>
    </section>
  </>;
}

export default ContactUsPage;
